export default __webpack_public_path__ + "static/media/iconfinder_clock.9838cc56.svg";